import { render, staticRenderFns } from "./createChannel.vue?vue&type=template&id=439d384b&scoped=true&"
import script from "./createChannel.vue?vue&type=script&lang=js&"
export * from "./createChannel.vue?vue&type=script&lang=js&"
import style0 from "./createChannel.vue?vue&type=style&index=0&id=439d384b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439d384b",
  null
  
)

export default component.exports